export const MIN_USERNAME_LENGTH = 3;

export function isValidOrgUsername(value: string | undefined): boolean {
  const trimmed = value?.trim() ?? "";
  return trimmed.length >= MIN_USERNAME_LENGTH && !/\s/.test(trimmed);
}
